<template>
    <CModal
        title="Увеличить время доставки"
        :show.sync="open"
        :footer="false"
        color="info"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm>
                    <CRow class="pl-3 mb-1">Увеличить время доставки до:</CRow>
                    <CRow>
                        <CCol>
                            <CInput
                                v-model="deliveryTime"
                                class="m-0"
                                type="time" />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CButton
                    color="light"
                    class="ml-3"
                    @click="$emit('stop-modal-close')"
                >Отмена</CButton
                >
                <CButton
                    color="danger"
                    class="ml-3"
                    @click="resetTime"
                >Сбросить</CButton
                >
                <CButton
                    color="primary"
                    class="ml-3"
                    @click="addTime"
                >Увеличить время доставки</CButton
                >
            </div>
        </template>
    </CModal>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'DeliveryModal',

        props: {
            open: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: ''
            },
            list: {
                type: Array,
                default: () => []
            },
        },

        data() {
            return {
                isAuthorized: false,
                deliveryTime: null,
                url: '',
            };
        },

        computed: {},

        mounted() {
            this.deliveryTime = '00:00';
            switch (this.type) {
            case BUSINESS_TYPE.RESTAURANT:
                this.url = `/restaurants/delivery-time`;
                break;
            case BUSINESS_TYPE.GROCER:
                this.url = `/grocers/delivery-time`;
                break;
            case BUSINESS_TYPE.ENTITY:
                this.url = `/entities/delivery-time`;
                break;
            default: return;
            }
        },

        methods: {
            async addTime() {
                const [hours, minutes] = this.deliveryTime.split(':');
                const deliveryTime = new Date(new Date().setHours(hours, minutes));

                try {
                    const ids = this.list.map(item => item.id);
                    const newDeliveryTime = await Vue.axios.post(this.url, { serviceIds: ids, deliveryTime: moment(deliveryTime).format('YYYY-MM-DD HH:mm:ss') });
                    this.$router.go(0);
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных. ' + err);
                }
                this.$emit('stop-modal-close');
            },
            async resetTime() {
                try {
                    const ids = this.list.map(item => item.id);
                    const newDeliveryTime = await Vue.axios.post(this.url, { serviceIds: ids, deliveryTime: null });
                    this.$router.go(0)
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных. ' + err);
                }
                this.$emit('stop-modal-close');
            },
        },
    };
</script>
